import { FC } from 'react';

interface Props {
  onReindex: () => void;
  disabled?: boolean;
}

/**
 * Botão "Re-indexar pasta" (Frente 5, S06). Dispara o `reindex_sharepoint_folder` via
 * mensagem do chat — força um refresh COMPLETO do índice da pasta (pega novos, reprocessa
 * alterados, remove órfãos). Útil quando a pasta mudou e o índice pode estar desatualizado.
 */
const ReindexButton: FC<Props> = ({ onReindex, disabled }) => (
  <button
    type="button"
    data-testid="reindex-button"
    onClick={onReindex}
    disabled={disabled}
    title="Forçar atualização do índice da pasta do SharePoint"
    className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-surface-tertiary border border-surface-border text-content-secondary hover:border-accent hover:text-accent transition disabled:opacity-40 disabled:cursor-not-allowed"
  >
    <span className="material-symbols-outlined text-base leading-none">sync</span>
    Re-indexar pasta
  </button>
);

export default ReindexButton;
